module.exports = __webpack_public_path__ + "welcome-img-178bf9fb836d0a1529256ffe415d7085.png";